import css from '../../TextEditor/components/TextEditorHr/TextEditorHr.module.css'

// Read-only horizontal rule for the static viewer; no Slate selection state.
const StaticHr = ({ attributes, children }: any) => (
    <div {...attributes}>
        <div contentEditable={false} className={css.hr} />
        {children}
    </div>
)

export default StaticHr
